import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { Control, Errors } from 'react-redux-form';
import classnames from 'classnames';
import Rating from './rating';
import Tooltip from './tooltip';
import TextareaAutosize from 'react-autosize-textarea';

class Textarea extends Component {
    textArea = props => <TextareaAutosize {...props} />;

    render() {
        let formRowClassNames = classnames({
            form__row: true,
            'form__row--error': !this.props.valid && this.props.touched,
            'form__row--disabled': this.props.disabled
        });
        return (
            <div className={formRowClassNames}>
                {this.props.tooltip && (
                    <Tooltip
                        title={this.props.tooltip}
                        className="form-tooltip"
                    />
                )}
                <label
                    htmlFor={this.props.model}
                    className="form__label form__label--textarea"
                >
                    <span className="form__title">
                        {this.props.title}
                        {this.props.isRequired ? (
                            <span className="form__required">*</span>
                        ) : (
                            ''
                        )}
                    </span>

                    {this.props.maxLength && (
                        <div className="form__quick-info">
                            (Note: Max Character Count is {this.props.maxLength})
                        </div>
                    )}

                    {this.props.rating ? (
                        <Rating
                            model={this.props.ratingModel}
                            disabled={this.props.disabled}
                            validators={this.props.ratingValidators}
                            messages={this.props.ratingMessages}
                        />
                    ) : null}

                    <Control.textarea
                        className="form__textarea"
                        model={this.props.model}
                        id={this.props.model}
                        disabled={this.props.disabled}
                        validators={this.props.validators}
                        maxLength={this.props.maxLength}
                        component={this.textArea}
                    />
                    <Errors
                        wrapper={props => (
                            <div className="form__error-messages">
                                {props.children}
                            </div>
                        )}
                        className="errors"
                        model={this.props.model}
                        show="touched"
                        messages={this.props.messages}
                    />
                </label>
            </div>
        );
    }
}

const mapStateToProps = (state, { model }) => ({
    valid: get(state.forms, `${model}.valid`, false),
    touched: get(state.forms, `${model}.touched`, false)
});

export default connect(mapStateToProps)(Textarea);



// WEBPACK FOOTER //
// ./src/components/ui/textarea.js